import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  DoughnutController,
} from "chart.js";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  ChartDataLabels,
  DoughnutController
);

const index = ({ data, options }: any) => {
  return <Doughnut data={data} options={options} />;
};

export default index;
